import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepareComponent } from './prepare.component';
import { FormsModule }   from '@angular/forms';
import {PdfViewerModule} from "ng2-pdf-viewer";
import {RequestModule} from "../request/request.module";
import { SharedModule } from '../shared/shared.module';
import { PdfFormDesignerComponent } from '../../../../libs/form-designer/projects/pdf-form-designer/src/public-api';

@NgModule({
    imports: [CommonModule, FormsModule, RequestModule, PdfViewerModule, SharedModule, PdfFormDesignerComponent, PrepareComponent],
    declarations: [],
    exports: [PrepareComponent]
})

export class PrepareModule { }
